<template>
  <div id="kktu-select" v-if="isShow()">
    <Multiselect @change="onChange" v-model="fields.value" mode="single" :placeholder="fields.label" noResultsText="Результатов не найдено" :searchable="true" :close-on-select="true" :options="fields.items" :trackBy="'title'" :max="1">
      <template v-slot:singlelabel="{ value }">
        <div class="multiselect-single-label option-item">
          <div class="item-name"> {{ value.title }}</div>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-item">
          <div class="item-name">
            {{ option.title }}
            <div class="item-path">
              <span class="item-level" :class="'level-' + option.level"></span>
              {{ option.path }}
            </div>
          </div>
        </div>
      </template>
    </Multiselect>
    <div v-if="v$.value.$invalid">
      <span :class="{'is-invalid': v$.value.$invalid && v$.value.$dirty}"></span>
      <div class="invalid-feedback" v-for="error of v$.value.$silentErrors" :key="error.$uid">
        {{ error.$message }}
      </div>
    </div>
    <template v-if="hasValidator()">
      <div v-if="fields.validator.kktu.$invalid">
        <span :class="{'is-invalid': fields.validator.kktu.$invalid && fields.validator.kktu.$dirty}"></span>
        <div class="invalid-feedback" v-for="error of fields.validator.kktu.$silentErrors" :key="error.$uid">
          {{ error.$message }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "./css/style.css"
import {computed, defineComponent, onMounted, reactive, ref, watch} from "vue"
import Multiselect from "@/plugins/multiselect"
import {useVuelidate} from "@vuelidate/core"
//import {required} from "@/plugins/vuelidator"

export default defineComponent({
  name: "Select",
  emits: ['onChangeVal'],
  components: {
    Multiselect,
  },
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let show = ref(false)
    let fields = reactive(getFields())
    let rules = computed(() => buildRules())

    let $externalResults = reactive({})

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function buildRules() {
      return {
        value: {
          //required,
        },
      }
    }

    function getFields() {
      return {
        validator: null,
        value: null,
        items: [],
        label: null,
      }
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    onMounted(async () => {
      markUnshow()
      await updateFields(props.payload)
      markShow()
    })

    watch(() => props.payload["validations"], (val) => {
      validate(() => {
        if (val?.category_id !== undefined) {
          $externalResults.category_id = val["category_id"][0]
        }
      })
    })

    async function updateFields(query) {
      fields.validator = query.validator
      fields.value = query.value
      fields.items = query.items
      fields.label = query.label
    }

    function onChange(value) {
      validate(() => {})
      pushParent(value)
    }

    function pushParent(value) {
      emit("onChangeVal", {
        category_id: value,
      })
    }

    function isShow() {
      return show.value === true
    }

    async function validate(fn) {
      v$.value.$clearExternalResults()

      return v$.value.$validate().then(async () => {
        await fn()
      })
    }

    function hasValidator() {
      return fields.validator !== null
    }

    return {
      onChange,
      fields,
      isShow,
      v$,
      hasValidator,
    }
  }
})
</script>
